var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar-items',[_c('div',{staticClass:"align-center font__20 font-weight-bold pt-4"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }